/**
 * Normalizes a score to a percentage (0–100) or ratio (0–1) based on the `to` parameter.
 *  - If `to` is 'percent', scores ≤1 are treated as ratios and multiplied by 100.
 *  - If `to` is 'ratio', scores >1 are treated as percentages and divided by 100.
 *  - If `to` is not specified, the original score is returned without modification.
 * 
 * @author Copilot
 */
export const normalizeScoreTo = (score: number, to?: 'percent' | 'ratio'): number => {
  const normalizeScoreToPercent = (s: number): number => (s <= 1 ? s * 100 : s);
  const normalizeScoreToRatio = (s: number): number => (s > 1 ? s / 100 : s);

  switch (to) {
    case 'percent':
      return normalizeScoreToPercent(score);
    case 'ratio':
      return normalizeScoreToRatio(score);
    default:
      return score;
  }
};
